import { render, staticRenderFns } from "./dialog-loading.vue?vue&type=template&id=b96300c6&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dialog-loading.vue"
export default component.exports